import { Drawer, Group } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import { Button } from "@tfg/ui"

import {
  fields,
  reactFormConfig,
} from "~/pages/Admin/Ingestion/Activities/createForm.config"
import { useCreateActivityMutation } from "~/pages/Admin/Ingestion/Activities/hooks/useCreateActivityMutation"
import { TypesForm } from "~/pages/Admin/components/TypesForm"

export function ActivityCreation() {
  const [drawerOpen, drawerActions] = useDisclosure(false)

  const { mutate: createActivity } = useCreateActivityMutation({
    onSuccess: drawerActions.close,
  })

  return (
    <>
      <Group justify="right">
        <Button onClick={drawerActions.open} icon={<IconPlus />}>
          New Activity
        </Button>
      </Group>
      <Drawer
        position="right"
        opened={drawerOpen}
        onClose={() => drawerActions.close()}
        title="Create an Activity"
        size="lg"
      >
        <TypesForm
          fields={fields}
          submitLabel="Create"
          formConfig={reactFormConfig}
          mutate={createActivity}
        />
      </Drawer>
    </>
  )
}
